import { render, staticRenderFns } from "./UserOredrsList.vue?vue&type=template&id=41191a65&scoped=true&"
import script from "./UserOredrsList.vue?vue&type=script&lang=js&"
export * from "./UserOredrsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41191a65",
  null
  
)

component.options.__file = "UserOredrsList.vue"
export default component.exports